module.exports = __webpack_public_path__ + "static/media/icon-participants.96590515.svg";